import React from "react";
import RadioButton from "@frameworks/web/components/generic/radioButton";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/GenericFilterSort/OfferingsRadioListFilters/OfferingsRadioListFilters.scss";
import { nanoid } from "nanoid";
var OfferingsRadioListFilters = function (props) {
    var _a;
    return (React.createElement("div", { className: "primary-offerings-radio-list-filters-container ".concat((_a = props === null || props === void 0 ? void 0 : props.parentClassName) !== null && _a !== void 0 ? _a : "") }, !!(props === null || props === void 0 ? void 0 : props.filterDataList) &&
        (props === null || props === void 0 ? void 0 : props.filterDataList.length) &&
        props.filterDataList.map(function (item) {
            var _a, _b;
            return (React.createElement(RadioButton, { className: "filters-radio-buttons", onChange: function (e) {
                    return !!(props === null || props === void 0 ? void 0 : props.onChangeCallback) && props.onChangeCallback(e, item);
                }, key: nanoid(), selected: props === null || props === void 0 ? void 0 : props.selectedRadioValue, list: {
                    display: item.label || item.name,
                    value: (_a = item.value) !== null && _a !== void 0 ? _a : item.value,
                }, name: (_b = item.value) === null || _b === void 0 ? void 0 : _b.toString() }));
        })));
};
export default OfferingsRadioListFilters;
